import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { activityInvoiceStyles } from "./style";
import { useState } from "react";
import CustomInput from "components/CustomInput";
import NotificationProvider from "components/NotificationProvider";
import { useUpdateActivityInvoiceDetailsMutation } from "../../../activityInvoiceSlice.js";
import { activityDetailsColumns } from "features/invoice/activity/activityInvoiceConsts";

const EditActivityInvoiceDetail = ({ invoice, open, setOpen, invoiceToEdit, setInvoiceToEdit }) => {
    const classes = activityInvoiceStyles();

    const [updateActivityInvoice, { isLoading }] = useUpdateActivityInvoiceDetailsMutation();

    const [isSaving, setIsSaving] = useState(false);

    const onChangeValue = (key, val) => {
        setInvoiceToEdit({ ...invoiceToEdit, [key]: val });
    }

    const onClose = () => {
        setOpen(false);
        setInvoiceToEdit(invoice);
    }
    const save = async () => {
        setIsSaving(true)
        let result = await updateActivityInvoice(invoiceToEdit);
        if (result && !result.error) {
            NotificationProvider.success("Invoice updated successfully");
        } else {
            NotificationProvider.error("Failed to update the invoice");
        }
        onClose()
        setIsSaving(false)
    }


    return (
        <>
            <Dialog open={open} onClose={onClose} aria-labelledby='dialog-title'>
                <DialogTitle id={'dialog-title'} >Edit Activity Invoice Details</DialogTitle>
                <DialogContent>
                    {activityDetailsColumns?.map((col) =>
                        col.editable == true &&
                        <div className={classes.input}>
                            <CustomInput
                                id={col.key}
                                label={col.label}
                                value={invoiceToEdit?.[col.key]}
                                numberOnly
                                required={false}
                                onChange={val => onChangeValue(col.key, val)}
                            />
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={isSaving} color='primary'>
                        Cancel
                    </Button>
                    <Button onClick={save} disabled={isSaving} color='primary' variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default EditActivityInvoiceDetail;